import api from './api';
import { User, MyRegistrationsData, DashboardClass } from '../types/models';

export async function getMe(): Promise<User> {
  const res = await api.get('/users/me');
  return res.data;
}

export async function updateMe(updates: Partial<Pick<User, 'name' | 'username' | 'defaultLocations' | 'notificationPreference' | 'optInNewEventNotifications'>> & { removePhone?: boolean; removeEmail?: boolean }): Promise<void> {
  await api.put('/users/me', updates);
}

export async function syncContact(): Promise<{ email: string | null; phone: string | null; emailVerified: boolean; phoneVerified: boolean }> {
  const res = await api.post('/users/me/sync-contact', {});
  return res.data;
}

export async function removeContactMethod(type: 'phone' | 'email'): Promise<void> {
  await api.put('/users/me', type === 'phone' ? { removePhone: true } : { removeEmail: true });
}

export async function listTeachers(): Promise<{ userId: string; name: string }[]> {
  const res = await api.get('/users/teachers');
  return res.data.teachers;
}

export async function getMyRegistrations(): Promise<MyRegistrationsData> {
  const res = await api.get('/users/me/registrations');
  return res.data;
}

export async function getMyClasses(): Promise<{ classes: DashboardClass[] }> {
  const res = await api.get('/users/me/classes');
  return res.data;
}
